import { BRANDS, type Brand } from '@/consts/brands';
import { BASE_PATH } from '@/consts/environmental';
import { urls } from '@/utils/urls';

const BRAND_SEGMENTS: string[] = Object.values(BRANDS);

const withoutBasePath = (path: string) =>
  path === BASE_PATH || path.startsWith(`${BASE_PATH}/`)
    ? path.slice(BASE_PATH.length)
    : path;

const withoutBrandSegment = (path: string) => {
  const [, first, ...rest] = path.split('/');

  return first && BRAND_SEGMENTS.includes(first) ? `/${rest.join('/')}` : path;
};

export const getLoginUrlWithRedirect = (brand: Brand, redirect: string) => {
  const loginUrl = urls[brand].legacy.auth.login;

  if (!redirect) {
    return loginUrl;
  }

  const target = redirect.replace(/\/register$/, '');
  // A relative path may arrive bare or middleware-rewritten (/sign-up/<brand>/…), so both normalise.
  const intended = /^https?:\/\//i.test(target)
    ? target
    : `${BASE_PATH}${withoutBrandSegment(withoutBasePath(target))}`;

  return `${loginUrl}?signupRedirect=${encodeURIComponent(intended)}`;
};
